import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-geolocator',
  templateUrl: './geolocator.component.html',
  styleUrls: ['./geolocator.component.css']
})
export class GeolocatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
